<!--
 * @Author: 前胡
 * @LastEditors: 胡椒
 * @Date: 2020-03-05 15:14:50
 * @LastEditTime: 2020-08-24 13:55:47
 * @Description: 账号管理搜索条
 -->
<template>
  <a-form class="filter-condition-form" layout="inline" :form="form" @submit="handleFormSubmit">
    <a-form-item>
      <a-input v-model="searchParams.search" style="width: 240px"  v-decorator="['mobile']" placeholder="注册手机/用户昵称" allowClear />
    </a-form-item>
  <!--  <a-form-item>
        <a-select style="width: 120px" v-model="searchParams.channel" placeholder="渠道筛选" allowClear>
          <a-select-option :value="i.value" v-for="i in channelOption" :key="i.value">{{i.label}}</a-select-option>
        </a-select>
      </a-form-item>-->
    <a-form-item>
      <a-button type="primary" html-type="submit" :loading="loading">查询</a-button>
    </a-form-item>
  </a-form>
</template>
<script>
import {channelOption} from '@/const/index'
export default {
  name: "WhiteListSearchBar",
  props: {
    searchParams: {
      type: Object,
      default: function() {
        return {};
      }
    },
    loading: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      channelOption,
      form: this.$form.createForm(this)
    };
  },
  methods: {
    handleFormSubmit(e) {
      e.preventDefault();
      this.form.validateFields(err => {
        if (!err) {
          this.$emit("callback", this.searchParams);
        }
      });
    },
  }
};
</script>
<style lang='less' scoped>
</style>
